import { Row, Col } from "antd";
import {
  FileCheck,
  Network,
  Users,
  Thermometer,
  Lightbulb,
  Monitor,
  ArrowLeftRight,
  ClipboardEdit,
} from "lucide-react";
import Subtitle from "../../Subtitle";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function InstalacionSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <>
      <Subtitle title="Características de la instalación" marginTop={16} />
      <Row gutter={[16, 16]}>
        <Col {...responsiveInfo}>
          <DataGroup
            title={"Clasificación"}
            formName="Clasificación de la verificación"
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              keyName="¿Es cambio de razón social?"
              icon={<ClipboardEdit size={16} />}
              iconColor="green"
              value={verification?.CambioRazonSocial}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              keyName="Tipo de verificación"
              icon={<FileCheck size={16} />}
              iconColor="black"
              value={verification?.TipoVerificacion}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Network size={16} />}
              iconColor="#1890ff"
              keyName="Tipo de instalación"
              value={verification?.TipoInstalacion}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              keyName="Tipo de concentración pública"
              icon={<Users size={16} />}
              iconColor="#1890ff"
              value={verification?.TipoConcentracion}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              keyName="Otro tipo de instalación"
              icon={<Users size={16} />}
              iconColor="#1890ff"
              value={verification?.TipoInstalacionOtro}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            title={"Valores"}
            formName="Valores de la instalación eléctrica"
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Thermometer size={16} />}
              iconColor="red"
              keyName="Tensión eléctrica de suministro"
              value={verification?.TensionElectricaSuministro}
              valueType="double"
              suffix="V"
              fieldWidth={16}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Lightbulb size={16} />}
              iconColor="darkgoldenrod"
              keyName="Carga instalada"
              value={verification?.CargaInstalada}
              valueType="double"
              suffix="kW"
              fieldWidth={16}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Monitor size={16} />}
              iconColor="#1890ff"
              keyName="Alcance de la verificación"
              value={verification?.AlcanceVerificacion}
              valueType="double"
              suffix="kW"
              fieldWidth={16}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ArrowLeftRight size={16} />}
              iconColor="darkgreen"
              keyName="Capacidad de la subestación"
              value={verification?.Capacidad}
              valueType="double"
              suffix="kVA"
              fieldWidth={16}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
      </Row>
    </>
  );
}